import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const AREA_LIBRARY = API_URL + "/library/";
const LIBRARY_CATEGORY_BASEURL = AREA_LIBRARY + "category/";
const POST_BASEURL = API_URL + "/LibraryPost/";

const POSTLINK_BASEURL = AREA_LIBRARY + "postlink/";

export const LibraryApi = {
  getCategoryList,
  downloadFile,
  renderLink,
  getVisaSecureTestTools,
};

function getCategoryList() {
  return axios.get(LIBRARY_CATEGORY_BASEURL + "getlist");
}

function getVisaSecureTestTools() {
  return axios.get(LIBRARY_CATEGORY_BASEURL + "getVisaSecureTestTools");
}

function downloadFile(id) {
  return axios.get(POST_BASEURL + "DownloadFile/" + id, { responseType: "blob" });
}

function renderLink(id) {
  return axios.get(POSTLINK_BASEURL + "GetPostLink/" + id);
}
